var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26638 14.7617H1.39997C1.17907 14.7617 1 14.5826 1 14.3617V11.8286C1 11.6077 1.17907 11.4286 1.39997 11.4286H5.26638C5.48728 11.4286 5.66635 11.6077 5.66635 11.8286V14.3617C5.66635 14.5826 5.48728 14.7617 5.26638 14.7617Z",
    stroke: "black",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9324 4.7627H5.06599C4.84509 4.7627 4.66602 4.58362 4.66602 4.36272V1.82956C4.66602 1.60866 4.84509 1.42958 5.06599 1.42958H8.9324C9.1533 1.42958 9.33237 1.60866 9.33237 1.82956V4.36272C9.33237 4.58362 9.1533 4.7627 8.9324 4.7627Z",
    stroke: "black",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6004 14.7617H8.73396C8.51306 14.7617 8.33398 14.5826 8.33398 14.3617V11.8286C8.33398 11.6077 8.51306 11.4286 8.73396 11.4286H12.6004C12.8213 11.4286 13.0003 11.6077 13.0003 11.8286V14.3617C13.0003 14.5826 12.8213 14.7617 12.6004 14.7617Z",
    stroke: "black",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 11.4291V9.09594C3.33203 8.35959 3.92894 7.7627 4.66528 7.7627H9.33163C10.068 7.7627 10.6649 8.35959 10.6649 9.09594V11.4291",
    stroke: "black",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.7625V4.7627",
    stroke: "black",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkIcon);
export default __webpack_public_path__ + "static/media/network-icon.f298d6db4f0abd1a5396b3866879ed9e.svg";
export { ForwardRef as ReactComponent };